import { defineComponent as _defineComponent } from 'vue'
import WorkflowCapabilityDescription from './WorkflowCapabilityDescription.vue';
import { FeatureTypes, ProductType } from '../../Billing/billing-types';
import { WORKFLOW_CAPABILITIES_MAP } from '@/components/dialogs/CouldntDowngradeBillingPlanDialog/capabilities-consts';
import { pluralize } from '@/utils/language-service';


export default /*#__PURE__*/_defineComponent({
  __name: 'CanStartTrial',
  props: {
    productType: null,
    reasons: null,
    trialEntitlements: null,
    trialButtonLoading: { type: Boolean },
    canEditBilling: { type: Boolean }
  },
  emits: ["start-trial"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'start-trial'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	productType: ProductType;
	reasons: FeatureTypes[];
	trialEntitlements: FeatureTypes[];
	trialButtonLoading: boolean;
	canEditBilling: boolean;
}

// @ts-ignore




const getReadableProductType = (reason: string) => pluralize(reason.replaceAll('product-', '').replaceAll('-', ' '), 1);

const startTrial = () => {
	emit('start-trial');
};

return { __sfc: true,props, emit, getReadableProductType, startTrial, WorkflowCapabilityDescription, WORKFLOW_CAPABILITIES_MAP }
}

})